import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import cn from 'classnames';
import { urlSearchParams } from '@utility/utills';
import { TouchableDiv } from '../../../components/common/Touchable/index';
import { ReactComponent as Searchimg } from '@assets/images/SearchIcon.svg';
import ModifierSearch from '@containers/OrderItemDetail/searchModifiersModal';
import {
  getPath,
  handleModifierClickFromSearch,
  onClickModifierHelper,
} from '../OrderItemDetailHandler';

const OrderItemDetailsMenu = props => {
  const { activeModGroup, setSelectedModGroup, modifierGroupsHashTable } = props;
  const { menuItemId } = useParams();
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [openKeyboard, setOpenKeyboard] = useState(false);

  const tablePopUp = {
    position: 'relative',
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    pointerEvents: 'auto',
    backgroundColor: props.serverAppTheme?.popUp_bg,
    backgroundClip: 'padding-box',
    height: '100%',
    border: props.serverAppTheme?.popupBorder,
    boxShadow: props.serverAppTheme?.popUp_box_shadow,
  };

  return (
    <div className="row mx-0 col-12 px-0">
      <div
        className="d-flex flex-nowrap col-12 overflowX px-0 my-2"  >
        {props.modifierLevelData?.length > 0 &&
        <>
          {props?.modifierLevelData?.map(el => {
            const isModifierRequired = el?.minimum > 0;
            return el?.hiddenMenuId != props.activeMenuItemId ? (
              <TouchableDiv
                key={el.id}
                className={cn(
                  'flex-shrink-0 inline-flex text-nowrap px-2 fs_16 py-1 mx-1 d-flex justify-content-center align-items-center fw-600',
                )}
                onClick={() => {
                  setSelectedModGroup({
                    [el.id]: !activeModGroup[el.id],
                  });
                }}
                style={{
                  minHeight: '33px',
                  color: activeModGroup[el.id] ?  props?.serverAppTheme?.btn_font_color : props?.serverAppTheme?.primary_text,
                  border: activeModGroup[el.id] ? 'none' : '1px solid #BEBEBE',
                  borderRadius: '104px',
                  backgroundColor: activeModGroup[el.id] ? props?.serverAppTheme?.primaryBtn : '#F1F1F1',
                }}
                rippleEffect={true}
              >
              {el?.shortName}
              {/* {isModifierRequired && <span className="fs_12">*</span>} */}
              </TouchableDiv>
            ) : null;
          })}
        </>
        }
      </div>

      {/* <div className={cn('col-1 px-1 d-flex align-items-center justify-content-end')}>
        <TouchableDiv
          role="button"
          tabIndex="0"
          className="d-flex rounded justify-content-center align-items-center"
          style={{
            backgroundColor: props.serverAppTheme?.card_bg,
            border: '1px solid #BEBEBE',
            height: '40px',
            width: '40px'
          }}
          onClick={e => {
            e.preventDefault();
            setOpenKeyboard(true);
            setSearchModalOpen(true);
          }}
          rippleEffect={true}
        >
          <Searchimg
            stroke={props.serverAppTheme?.notification_time_font}
            height={26}
            width={26}
          />
        </TouchableDiv>
      </div> */}

      {searchModalOpen && (
        <ModifierSearch
          isOpen={searchModalOpen}
          serverAppTheme={props.serverAppTheme}
          customClass2={cn('w-100 h-100')}
          customClass=""
          placeholderName="Search items"
          setSearchModalOpen={setSearchModalOpen}
          setOpenKeyboard={setOpenKeyboard}
          openKeyboard={openKeyboard}
          style={tablePopUp}
          modifierGroupsHashTable={modifierGroupsHashTable}
          menuItemId={menuItemId}
          modifierLevelData={props.modifierLevelData}
          getPath={getPath}
          onModifierClickFromSearch={(data) => handleModifierClickFromSearch(data, setSearchModalOpen)}
        />
      )}

      {/* {!props.isNestedModifier &&
        props.menusList[props.menuIndex]?.globalModifierGroupIds
          ?.length !== 0 && (
          <div
            className={cn(
              'd-flex flex-row o-group-menu overflowX w-100 overflowY align-items-center pt-2 pb-2'
            )}
          >
            {props.menusList[
              props.menuIndex
            ].globalModifierGroupIds?.map(modFunc => {
              return (
                <TouchableButton
                  key={modFunc}
                  className={cn(
                    'flex-shrink-0 inline-flex text-nowrap px-3 mx-1 fs_16 fw-500 rounded-pill py-1'
                  )}
                  onClick={e => {
                    e.preventDefault();
                    if (props.globalModEnabled) {
                      return;
                    }
                  }}
                  style={{
                    color: props?.serverAppTheme?.primary_text,
                    border: `1px solid ${props?.serverAppTheme?.modifiers_border}`,
                  }}
                  rippleEffect={true}
                >
                  {props.modifierGroupsHashTable[modFunc].name}
                </TouchableButton>
              );
            })}
          </div>
        )} */}
    </div>
  );
};

const mapStateToProps = ({ orders, theme }) => ({
  activeMenuItemId: Number(urlSearchParams('menuId')) || 0,
  modifierLevelData: orders.modifierLevelData,
  serverAppTheme: theme.serverAppTheme,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OrderItemDetailsMenu));
